import {Banner} from '@wandb/components';
import React from 'react';

import type {FileInfo} from '../fileInfoFromName';
import type {PatchFileState} from './usePatchFile';

type PatchErrorProps = {
  fileInfo: FileInfo;
  patchState: PatchFileState;
};
export function PatchError({fileInfo, patchState}: PatchErrorProps) {
  if (patchState.status !== 'error') {
    return null;
  }

  // Always show the error if the patch application failed, the fetch failed,
  // or some unhandled error happened in the patch fetch/application process.
  // These errors indicate that the patch viewer is likely broken, so we want to
  // show the error message to the user.
  if (
    patchState.reason === 'apply-failed' ||
    patchState.reason === 'fetch-failed' ||
    patchState.reason === 'unknown-error'
  ) {
    return (
      <div className="p-8">
        <Banner variant="error" isDismissible={false}>
          {patchState.error}
        </Banner>
      </div>
    );
  }

  // Only show not-found style errors for Python and Dockerfile patches, since
  // those are the only files that are likely to be in the artifact, so we want
  // to notify the user if they don't exist.
  //
  // TODO: we should change this after the Jira ticket
  //       <https://wandb.atlassian.net/browse/WB-32195> is completed, because
  //       that should change the SDK to include all unstaged files in the code
  //       artifact, which would make not-found errors for other file types
  //       an unexpected error.
  if (fileInfo.language === 'python' || fileInfo.language === 'dockerfile') {
    return (
      <div className="p-8">
        <Banner variant="warning" isDismissible={false}>
          {patchState.error}
        </Banner>
      </div>
    );
  }

  return null;
}
